import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//UI
import { Row, Col, message } from "antd";
import { RequiredFormLabel } from "../RequiredFormLabel/RequiredFormLabel";
import { Input } from "../../Common/Input";
import { Button, ButtonPrimary } from "../../Common/Button";
import OnboardingPropertyDropdown from "../../Onboarding/PropertySelect/OnboardingPropertyDropdown";
import { Form } from "@ant-design/compatible";

//Processing
import {
  useCreatePropertyContact,
  useUpdatePropertyContact,
} from "../../../hooks/Onboarding/onboarding-property-contacts.hooks";
import {
  ONBOARDING_PROPERTY_CONTACT_STATUS,
  RECORD_OPERATIONS,
} from "../../../utils/onboarding-helper";

import {
  propertyContactAddSchema,
  propertyContactEditSchema,
} from "../../../schema/onboarding-properties.schema";

const PropertyUserForm = (props) => {
  const {
    closeDrawer,
    operationData,
    operation,
    customer,
    successRedirect,
    setProperty,
  } = props;

  const history = useHistory();

  const currentPropertyContactSchema = useMemo(() => {
    switch (operation) {
      case RECORD_OPERATIONS.ADD:
        return propertyContactAddSchema;
      default:
        return propertyContactEditSchema;
    }
  }, [operation]);

  const {
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    control,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(currentPropertyContactSchema),
  });

  const { mutateAsync: updatePropertyContact } = useUpdatePropertyContact({
    onSuccess: () => {
      message.success("Property contact successfully edited");
      history.push(
        successRedirect ||
          `/onboarding/users?customer=${customer}&queryTab=corporate_user`,
      );
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const { mutateAsync: createPropertyContact } = useCreatePropertyContact({});

  const formFirstStepSubmit = async (submitData) => {
    console.log("Form1", submitData);
    if (operation == RECORD_OPERATIONS.EDIT) {
      await updatePropertyContact(submitData);
    } else {
      if (customer === "") {
        message.error("Please select a Customer");
        closeDrawer();
        return;
      }
      submitData.customer_id = customer;
      // await createPropertyContact(submitData);
    }
  };

  let property = operationData.property_name;
  useEffect(() => {
    clearErrors();
    reset({});
    if (operation == RECORD_OPERATIONS.EDIT) {
      reset({
        _id: operationData._id,
        first_name: operationData.first_name,
        last_name: operationData.last_name,
        phone_number: operationData.phone_number,
        email: operationData.email,
        property_id: operationData._id,
        customer_id: operationData.customer_id,
        status: operationData.status,
      });
    }
  }, [operation, operationData]);

  return (
    <div>
      <Form onSubmit={handleSubmit(formFirstStepSubmit)} layout="vertical">
        <Row>
          <Form.Item
            label={<RequiredFormLabel value="Property Name" />}
            help={errors?.property_id?.message}
            validateStatus={errors?.property_id ? "error" : ""}
          >
            <Controller
              control={control}
              name="property_id"
              render={({ field }) => (
                <OnboardingPropertyDropdown
                  {...field}
                  property={property}
                  setProperty={setProperty}
                  customer={customer}
                />
              )}
            />
          </Form.Item>
          <Form.Item
            label={<RequiredFormLabel value="Property Contact First Name" />}
            help={errors?.first_name?.message}
            validateStatus={errors?.first_name ? "error" : ""}
          >
            <Controller
              control={control}
              name="first_name"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Property Contact First Name"
                />
              )}
            ></Controller>
          </Form.Item>
          <Form.Item
            label={<RequiredFormLabel value="Property Contact Last Name" />}
            help={errors?.last_name?.message}
            validateStatus={errors?.last_name ? "error" : ""}
          >
            <Controller
              control={control}
              name="last_name"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Property Contact Last Name"
                />
              )}
            ></Controller>
          </Form.Item>
          <Form.Item
            label="Property Contact Phone Number"
            help={errors?.phone_number?.message}
            validateStatus={errors?.phone_number ? "error" : ""}
          >
            <Controller
              control={control}
              name="phone_number"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Property Contact Phone Number"
                />
              )}
            ></Controller>
          </Form.Item>
          <Form.Item
            label={<RequiredFormLabel value="Property Contact Email" />}
            help={errors?.email?.message}
            validateStatus={errors?.email ? "error" : ""}
          >
            <Controller
              control={control}
              name="email"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Property Contact Email"
                  disabled={
                    operation == RECORD_OPERATIONS.EDIT &&
                    getValues("status") !=
                      ONBOARDING_PROPERTY_CONTACT_STATUS.IN_DRAFT
                  }
                />
              )}
            ></Controller>
          </Form.Item>
        </Row>
        <Row>
          <Col span={12}>
            <Button
              style={{ width: "150px" }}
              htmlType="button"
              onClick={() => {
                reset({});
                closeDrawer();
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <ButtonPrimary
              style={{ width: "150px" }}
              htmlType="submit"
              disabled={
                (operation === RECORD_OPERATIONS.EDIT &&
                  getValues("status") !==
                    ONBOARDING_PROPERTY_CONTACT_STATUS.IN_DRAFT &&
                  getValues("status") ===
                    ONBOARDING_PROPERTY_CONTACT_STATUS.PENDING) ||
                operation === RECORD_OPERATIONS.ADD
              }
            >
              Save
            </ButtonPrimary>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default PropertyUserForm;
